import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import Transition from 'utils/hocs/transition';
import { enableDarkThemeFromOS } from '__config/styleguide/colors';
import css from './styles.module.scss';

// import Header from 'components/organisms/header';
import Footer from 'components/organisms/footer';
import SkipLinks from 'components/molecules/skip-links';

const Layout = ({ children, settingsTemplate, footerData }) => {
  const router = useRouter();

  const [timestamp, setTimestamp] = useState(null);
  const hideFooter = settingsTemplate?.hideFooter;

  useEffect(() => {
    setTimestamp(new Date().toUTCString());
  }, []);

  const shouldShowFooter = !router.isFallback && !hideFooter;
  return (
    <div className={css['layout']} data-generated-at={timestamp} data-theme={enableDarkThemeFromOS ? 'os' : 'light'}>
      <SkipLinks />
      <Transition location={router.pathname}>{!router.isFallback && children}</Transition>

      {shouldShowFooter && <Footer locale={router?.locale?.toLowerCase()} data={footerData}/>}
    </div>
  );
};

export default Layout;
